import { render, staticRenderFns } from "./viewScoreItems.vue?vue&type=template&id=bfdb0164&scoped=true"
import script from "./viewScoreItems.vue?vue&type=script&lang=js"
export * from "./viewScoreItems.vue?vue&type=script&lang=js"
import style0 from "./viewScoreItems.vue?vue&type=style&index=0&id=bfdb0164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdb0164",
  null
  
)

export default component.exports